
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, UserCheck, Wrench } from 'lucide-react';

const AnalystWorkflowDiagram = () => {
  const workflowSteps = [
    {
      icon: <Shield size={32} className="text-primary" />,
      title: "Automated Detection",
      description: "Platform flags anomalous activity using a multi-layered detection engine.",
    },
    {
      icon: <UserCheck size={32} className="text-accent" />,
      title: "Human Validation",
      description: "Our Australian-based analysts verify the threat, discard false positives, and assess the risk.",
      highlight: true,
    },
    {
      icon: <Wrench size={32} className="text-primary" />,
      title: "Guided Remediation",
      description: "You receive a clear, actionable report with steps to fix the issue, backed by expert support.",
    },
  ];

  return (
    <div className="relative">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        {workflowSteps.map((step, index) => (
          <>
            <Card
              key={step.title}
              className={`cyber-card w-full ${step.highlight ? 'border-accent/50 glow-border' : 'border-primary/20'}`}>
              <CardHeader className="text-center">
                <div className="mx-auto w-fit mb-4 bg-card p-3 rounded-full border border-border">{step.icon}</div>
                <CardTitle>{step.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center text-muted-foreground text-sm">
                {step.description}
              </CardContent>
            </Card>
            {index < workflowSteps.length - 1 && (
                <div className="hidden md:block h-1 w-full bg-border relative">
                    <div className="h-1 w-full bg-primary/30 animate-pulse"/>
                </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default AnalystWorkflowDiagram;
